import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@shadcn-in-nx/ui/button";
import { X, ArrowRight } from "lucide-react";

// Guided Automation Tooltip Component
function GuidedTooltip({ step, position, onNext, onSkip, isVisible }) {
    const { t } = useTranslation();

    if (!isVisible || !step) return null;

    return (
        <div
            className="fixed z-50 bg-black text-white p-4 rounded-lg shadow-xl max-w-sm"
            style={{
                left: position.x,
                top: position.y,
                transform: "translate(-50%, -100%)",
            }}
        >
            <div className="flex justify-between items-start mb-2">
                <h3 className="font-semibold text-sm">
                    {t("guidedTooltip.title")}
                </h3>
                <button
                    onClick={onSkip}
                    className="text-gray-300 hover:text-white"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
            <p className="text-sm mb-3">{step.instruction}</p>
            <div className="flex justify-between items-center">
                <span className="text-xs text-gray-300">
                    {t("guidedTooltip.stepCounter", {
                        currentStep: step.stepNumber,
                        totalSteps: step.totalSteps,
                    })}
                </span>
                <Button
                    onClick={onNext}
                    size="sm"
                    className="bg-white text-black hover:bg-gray-200"
                >
                    {step.isLast
                        ? t("guidedTooltip.finishButton")
                        : t("guidedTooltip.nextButton")}
                    <ArrowRight className="w-3 h-3 ml-1" />
                </Button>
            </div>
        </div>
    );
}

export default GuidedTooltip;
